import { getMessages } from '../../../../../../../store/constants';

export const CHECKLIST_DROPPABLE_LABEL = getMessages().getText('card_form_checklist_droppable');
